import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': SessionManager.getCookie('user_token'),
})

export const orderList = createAsyncThunk('order/list', async ({ pageable: data, navigate }) => {
    try {
        return await axios({
            method: 'GET',
            url: getConfig.API_URL + 'order_management',
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                order_status: data?.order_status,
                payment_status: data?.payment_status,
                search: data?.search,
            },
            headers: headers(),
        })
    } catch (error) {
        return error.response
    }
})

export const orderDetails = createAsyncThunk('order/details', async ({ id, navigate }) => {
    try {
        return await axios({
            method: 'GET',
            url: getConfig.API_URL + `order_management/${id}`,
            headers: headers(),
        })
    } catch (error) {
        return error.response
    }
})

export const updateOrderStatus = createAsyncThunk('order/updateStatus', async ({ id, values }) => {
    try {
        return await axios({
            method: 'PATCH',
            url: getConfig.API_URL + `order_management/${id}/status`,
            data: {
                order_status: values?.order_status,
                carrier_name: values?.carrier_name || null,
                tracking_number: values?.tracking_number || null,
                tracking_url: values?.tracking_url || null,
                reason: values?.reason || null,
                internal_remarks: values?.internal_remarks || null,
            },
            headers: headers(),
        })
    } catch (error) {
        return error.response
    }
})

export const generateOrderInvoice = createAsyncThunk('order/generateInvoice', async ({ id, navigate }) => {
    try {
        return await axios({
            method: 'GET',
            url: getConfig.API_URL + `order_management/${id}/invoice`,
            headers: {
                Authorization: SessionManager.getCookie('user_token'),
                Accept: 'text/html',
            },
            responseType: 'text',
        })
    } catch (error) {
        return error.response
    }
})


const handleAuthError = (action) => {
    if (action?.payload?.status === 401) {
        showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
    } else if (action?.payload?.status === 403) {
        showAccessDeniedAlert(action.meta.arg.navigate)
    }
}

const order = createSlice({
    name: 'order',
    initialState: {
        list: [],
        details: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(orderList.fulfilled, (state, action) => {
                if (action?.payload?.status === 200) {
                    state.list = action.payload.data.data || []
                } else {
                    state.list = []
                    handleAuthError(action)
                }
            })
            .addCase(orderDetails.fulfilled, (state, action) => {
                if (action?.payload?.status === 200) {
                    state.details = action.payload.data.data || null
                } else {
                    handleAuthError(action)
                }
            })
            .addCase(generateOrderInvoice.fulfilled, (state, action) => {
                if (action?.payload?.status !== 200) {
                    handleAuthError(action)
                }
            })
    },
})

export default order.reducer;